import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const MicrosoftCallback = () => {
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Since we're now using MSAL popup flow, this callback is no longer needed
    // But we'll handle any edge cases where users might still land here
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');
    
    if (error) {
      console.error('Authentication error in callback:', error, errorDescription);
      setError(errorDescription || 'Authentication failed');
      setTimeout(() => navigate('/login'), 3000);
      return;
    }
    
    // If no error, redirect to login to use the new MSAL flow
    console.log('Redirecting to login to use MSAL popup flow');
    navigate('/login', { replace: true });
  }, [navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <div className="text-center">
        {!error ? (
          <>
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <h4>Processing your Microsoft login...</h4>
            <p>Please wait while we authenticate you.</p>
          </>
        ) : (
          <div className="alert alert-danger" role="alert">
            <h4>Authentication Error</h4>
            <p>{error}</p>
            <p>Redirecting to login page...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MicrosoftCallback;